module.exports = __webpack_public_path__ + "img/three_side_left_img.083132c3.png";